import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import HistoryItem from '@/components/formats/RirekishoParts/HistoryItem.vue'
import NewRirekishoExampleSentenceDialog from '@/components/format-edit/new-rirekisho/NewRirekishoExampleSentenceDialog.vue'
import {
  useRirekishoFormatData,
  type RirekishoExampleSentence,
  type RirekishoExampleSentences
} from '@/composables/format-edit/useRirekishoFormatData'
import { useRirekishoHistoriesApi } from '@/composables/format-edit/useRirekishoHistories'
import type { BasicData } from '@/utils/format-edit/basicData'


export default /*#__PURE__*/_defineComponent({
  __name: 'RirekishoLicenseCard',
  props: {
    currentCardId: null,
    formatId: null,
    basicData: null,
    previewErrors: null,
    exampleSentences: null
  },
  setup(__props: any) {

const props = __props as {
  currentCardId?: string
  formatId?: string
  basicData: BasicData
  previewErrors: Record<string, string>
  exampleSentences?: RirekishoExampleSentences
};

const descriptionMaxLength = 80



const formatData = useRirekishoFormatData()
const {
  activeHistoryItem,
  addLicenseHistory,
  deleteLicenseHistory,
  moveLicenseHistory,
  activateHistoryItem
} = useRirekishoHistoriesApi()

const exampleVisible = ref(false)

const licenseExamples = computed(() => props.exampleSentences?.license || [])

function onSelectExample(item: RirekishoExampleSentence) {
  addLicenseHistory(null, { description: item.description })
}

return { __sfc: true,descriptionMaxLength, props, formatData, activeHistoryItem, addLicenseHistory, deleteLicenseHistory, moveLicenseHistory, activateHistoryItem, exampleVisible, licenseExamples, onSelectExample, HistoryItem, NewRirekishoExampleSentenceDialog }
}

})